import { Button, Text } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DistributionRuleDrawer } from '@dealstack/frontend/app/pages/Valuations/views/BreakpointSummary/DistributionRule/DistributionRuleDrawer';
import { DistributionRuleScope } from '@dealstack/frontend/app/pages/Valuations/views/BreakpointSummary/DistributionRule/DistributionRuleTable';
import { useTranslationValuations } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { VALUATION_ELEMENT_ID } from '@dealstack/shared/tests/testElementIds';
import { BreakpointSummaryPayload, CurrencyType } from '@dealstack/shared/lib/generated';

interface Props {
	isLoading: boolean;
	breakpointSummaryData: BreakpointSummaryPayload | undefined;
	currency: CurrencyType;
	scope?: DistributionRuleScope;
}

export const DistributionRuleButton = ({
	isLoading,
	breakpointSummaryData,
	currency,
	scope,
}: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const shouldAutoOpen = useRef(searchParams.has('openDrawer'));
	const [opened, setOpened] = useState(shouldAutoOpen.current);

	useEffect(() => {
		if (shouldAutoOpen.current) {
			shouldAutoOpen.current = false;
			searchParams.delete('openDrawer');
			setSearchParams(searchParams, { replace: true });
		}
	}, [searchParams, setSearchParams]);

	const tValuations = useTranslationValuations();

	return (
		<>
			<Button
				data-testid={VALUATION_ELEMENT_ID.BREAKPOINT_DISTRIBUTION_RULES_BTN}
				variant="default"
				onClick={() => {
					setOpened(true);
				}}
				disabled={isLoading}
			>
				<Text size="B6Medium" c="dark.9">
					{tValuations('breakpoint_summary.distribution_rules_button')}
				</Text>
			</Button>
			<DistributionRuleDrawer
				opened={opened}
				onClose={() => setOpened(false)}
				breakpointSummaryData={breakpointSummaryData}
				isLoading={isLoading}
				currency={currency}
				scope={scope}
			/>
		</>
	);
};
